import React, { useEffect } from "react";
import Styles from "./main.module.css";
import HomeContent1 from "./home_content1";
import FloatingAbout from "./FloatingAbout";
import OurPartners from "./ourPartners";
import Slidersaga from "./Servicess";
import CustomerService from "./CustomerService";
import Complaints from "./Complaints";
import SignupBox from "./SignupBox";
import Faqs from "./Faqs";
import VideoSlider from "./VideoSlider";
import SampleBlogs from "./SampleBlogs";
import Nav from "../Nav/Nav";
import Footer from "../Footer/Footer";
import useStore from "../../../Store";
import Testimonials from "./testimonials";
import HomeSlider from "./HomeSilder";
import HomepageCounter from "./HomepageCounter";
import Review from "./reviews";
import { useLocation } from "react-router-dom";
import About1 from "../AboutPage/About1";
import Progress from "../AboutPage/Progress";
import Insurence from "../AboutPage/Insurence";
import TeamConnect from "../AboutPage/TeamConnect";
import WhyChooseUs from "./WhyChooseUs";
import NewCalendar from "./NewCalendar";
import DataDocumentAccess from "./DataDocumentAccess";

const Home = () => {
  const direction = useStore((state) => state.direction);
  const location = useLocation();

  useEffect(() => {
    // Scroll to the section if hash exists
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div style={{ direction }}>
      <Nav />
      <div className={Styles.home_container}>
        <HomeContent1 />
        <HomepageCounter />
        <DataDocumentAccess />
        <Slidersaga />
        <WhyChooseUs />
        <OurPartners />
        {/* <Complaints /> */}
        <NewCalendar />
        {/* <CustomerService /> */}
        <SignupBox />
        <Faqs id="faqs" />
        {/* <VideoSlider /> */}
        <SampleBlogs />
        <HomeSlider id="Testimonials" />
        {/* <Progress /> */}
        {/* <Insurence /> */}
        <TeamConnect />
        <FloatingAbout />
      </div>
      <Footer />
    </div>
  );
};

export default Home;
